window.components.accordionItem = {
    selector: "[accordion-item]",

    init: function () {
        this.events();
    },

    events: function () {
        $("body").on("click", ".accordion-item", this.onClickAccordion);
    },

    onClickAccordion: function (e) {
        $(this).find(".accordion-content").toggle();
        $(this)
            .siblings(".accordion-item")
            .find(".accordion-content")
            .slideUp();
        var width = $(window).width();
        if (width >=1024){ 
             $('html, body').animate({
                scrollTop: $(".nutritional-info h3").offset().top - 100
            });
        }
    },
};
